import { initLoaderPage } from "@papilio-loader/loader-ui/loader-page.js";

initLoaderPage();
